import { TaxMeHistoryRaw } from "@features/product/model/taxMeModel";

/**
 * 로그인한 계정의 세금 계산서 조회
 * [GET] /tax/me/history
 */
export const taxMeHistoryData: TaxMeHistoryRaw = [
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 3, goodsName: "3", supplyAmount: 29342, taxAmount: 41429 },
  { billCode: 1, goodsName: "4", supplyAmount: 123292, taxAmount: 292342 },
  { billCode: 3, goodsName: "5", supplyAmount: 56292, taxAmount: 4000 },
  { billCode: 2, goodsName: "6", supplyAmount: 52292, taxAmount: 533292 },
  { billCode: 1, goodsName: "7", supplyAmount: 33292, taxAmount: 2952292 },
  { billCode: 4, goodsName: "8", supplyAmount: 8275592, taxAmount: 52292 },
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 3, goodsName: "3", supplyAmount: 29342, taxAmount: 41429 },
  { billCode: 1, goodsName: "4", supplyAmount: 123292, taxAmount: 292342 },
  { billCode: 3, goodsName: "5", supplyAmount: 56292, taxAmount: 4000 },
  { billCode: 2, goodsName: "6", supplyAmount: 52292, taxAmount: 533292 },
  { billCode: 1, goodsName: "7", supplyAmount: 33292, taxAmount: 2952292 },
  { billCode: 4, goodsName: "8", supplyAmount: 8275592, taxAmount: 52292 },
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 3, goodsName: "3", supplyAmount: 29342, taxAmount: 41429 },
  { billCode: 1, goodsName: "4", supplyAmount: 123292, taxAmount: 292342 },
  { billCode: 3, goodsName: "5", supplyAmount: 56292, taxAmount: 4000 },
  { billCode: 2, goodsName: "6", supplyAmount: 52292, taxAmount: 533292 },
  { billCode: 1, goodsName: "7", supplyAmount: 33292, taxAmount: 2952292 },
  { billCode: 4, goodsName: "8", supplyAmount: 8275592, taxAmount: 52292 },
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 3, goodsName: "3", supplyAmount: 29342, taxAmount: 41429 },
  { billCode: 1, goodsName: "4", supplyAmount: 123292, taxAmount: 292342 },
  { billCode: 3, goodsName: "5", supplyAmount: 56292, taxAmount: 4000 },
  { billCode: 2, goodsName: "6", supplyAmount: 52292, taxAmount: 533292 },
  { billCode: 1, goodsName: "7", supplyAmount: 33292, taxAmount: 2952292 },
  { billCode: 4, goodsName: "8", supplyAmount: 8275592, taxAmount: 52292 },
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 3, goodsName: "3", supplyAmount: 29342, taxAmount: 41429 },
  { billCode: 1, goodsName: "4", supplyAmount: 123292, taxAmount: 292342 },
  { billCode: 3, goodsName: "5", supplyAmount: 56292, taxAmount: 4000 },
  { billCode: 2, goodsName: "6", supplyAmount: 52292, taxAmount: 533292 },
  { billCode: 1, goodsName: "7", supplyAmount: 33292, taxAmount: 2952292 },
  { billCode: 4, goodsName: "8", supplyAmount: 8275592, taxAmount: 52292 },
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 3, goodsName: "3", supplyAmount: 29342, taxAmount: 41429 },
  { billCode: 1, goodsName: "4", supplyAmount: 123292, taxAmount: 292342 },
  { billCode: 3, goodsName: "5", supplyAmount: 56292, taxAmount: 4000 },
  { billCode: 2, goodsName: "6", supplyAmount: 52292, taxAmount: 533292 },
  { billCode: 1, goodsName: "7", supplyAmount: 33292, taxAmount: 2952292 },
  { billCode: 4, goodsName: "8", supplyAmount: 8275592, taxAmount: 52292 },
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 3, goodsName: "3", supplyAmount: 29342, taxAmount: 41429 },
  { billCode: 1, goodsName: "4", supplyAmount: 123292, taxAmount: 292342 },
  { billCode: 3, goodsName: "5", supplyAmount: 56292, taxAmount: 4000 },
  { billCode: 2, goodsName: "6", supplyAmount: 52292, taxAmount: 533292 },
  { billCode: 1, goodsName: "7", supplyAmount: 33292, taxAmount: 2952292 },
  { billCode: 4, goodsName: "8", supplyAmount: 8275592, taxAmount: 52292 },
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 3, goodsName: "3", supplyAmount: 29342, taxAmount: 41429 },
  { billCode: 1, goodsName: "4", supplyAmount: 123292, taxAmount: 292342 },
  { billCode: 3, goodsName: "5", supplyAmount: 56292, taxAmount: 4000 },
  { billCode: 2, goodsName: "6", supplyAmount: 52292, taxAmount: 533292 },
  { billCode: 1, goodsName: "7", supplyAmount: 33292, taxAmount: 2952292 },
  { billCode: 4, goodsName: "8", supplyAmount: 8275592, taxAmount: 52292 },
  { billCode: 1, goodsName: "1", supplyAmount: 4000, taxAmount: 110000 },
  { billCode: 2, goodsName: "2", supplyAmount: 292342, taxAmount: 2229 },
  { billCode: 3, goodsName: "3", supplyAmount: 29342, taxAmount: 41429 },
  { billCode: 1, goodsName: "4", supplyAmount: 123292, taxAmount: 292342 },
  { billCode: 3, goodsName: "5", supplyAmount: 56292, taxAmount: 4000 },
  { billCode: 2, goodsName: "6", supplyAmount: 52292, taxAmount: 533292 },
  { billCode: 1, goodsName: "7", supplyAmount: 33292, taxAmount: 2952292 },
  { billCode: 4, goodsName: "8", supplyAmount: 0, taxAmount: 52292 },
];
